import React from "react";
import "./error.css";

function Error({oops}) {

    let phrase

    (oops.code === "auth/account-exists-with-different-credential") ? 
        phrase="Looks like that email is linked to another one of your accounts - did you previously log in with Google or Facebook?" : 
        phrase =`🥴 ${oops.code}`
        
    return (
        <div className="error">
            {phrase}
        </div>
    );
}

export default Error;
